module.exports = __webpack_public_path__ + "img/product_108.16e4584.webp";